// extracted by mini-css-extract-plugin
export default {"root":"FreemiumAboutModal__root--17FM8"};